import { CalendarCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "../constants";

const STEPS = [
  { n: "01", title: "Anfrage senden", desc: "Kontaktieren Sie uns telefonisch, per WhatsApp oder über das Formular." },
  { n: "02", title: "Kostenlose Objektbesichtigung", desc: "Wir besprechen vor Ort Ihren konkreten Reinigungsbedarf." },
  { n: "03", title: "Individuelles Angebot", desc: "Sie erhalten ein auf Ihr Objekt zugeschnittenes Angebot." },
];

export const Process = () => (
  <section className="bg-white py-16 md:py-24" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Chapter number="04" label="Der Ablauf" />
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink max-w-2xl">
          In drei Schritten zu Ihrem Angebot
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 relative">
        <div className="hidden md:block absolute top-9 left-[16%] right-[16%] border-t-2 border-dashed border-ice" aria-hidden="true" />
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="relative" data-testid={`process-step-${i + 1}`}>
              <span className="font-heading text-7xl font-extrabold text-ice leading-none select-none">
                {s.n}
              </span>
              <h3 className="font-heading text-xl sm:text-2xl font-medium text-ink mt-4">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-mutedtext leading-relaxed max-w-xs">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <button
          onClick={() => scrollToId("kontakt")}
          className="mt-14 inline-flex items-center gap-2.5 rounded-full bg-conv hover:bg-conv-dark text-white font-semibold px-8 py-4 transition-all duration-200 hover:scale-[1.03] shadow-[0_16px_32px_-12px_rgba(16,185,129,0.55)]"
          data-testid="process-cta-besichtigung"
        >
          <CalendarCheck className="w-5 h-5" />
          Kostenlose Objektbesichtigung vereinbaren
        </button>
      </Reveal>
    </div>
  </section>
);
